import { formatters } from '@utils/formattersV2';
import { SplineChartWithHeader } from '../../../../../../components/Summary/SplineChartWithHeader';
import { unifiedPlatformColorPalette } from '@utils/unifiedPlatformColorPalette';
import {
  Lci3Report,
  Lci3SalesMetrics,
} from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { reportsToSeriesData } from '../../../../utils';

type IncrementalSalesSplineChartProps = {
  reports: Lci3Report[];
  salesMetrics: Lci3SalesMetrics;
};

export const IncrementalSalesSplineChart = (
  props: IncrementalSalesSplineChartProps
) => {
  const incrementalSalesSplineData = reportsToSeriesData({
    reports: props.reports,
    type: 'sales',
    field: 'incrementalSales',
  });

  return (
    <SplineChartWithHeader
      data={incrementalSalesSplineData}
      color={unifiedPlatformColorPalette.chartLightGreen}
      formatter={value =>
        formatters.currency(value, { full: true, decimals: 0 })
      }
      yAxisLabelFormatter={value => formatters.currency(value, { decimals: 0 })}
      title="Incremental Sales"
      differenceType="standard"
      confidenceLevel={props.salesMetrics.confidenceLevel.total ?? undefined}
      data-testid="incremental-sales-chart"
    />
  );
};
